export const healthIndicatorQuestionnaire = {
  digitalHeathQuestionnaire: "Cuestionario de Salud Digital",
  pdfTitle: "{country} - Cuestionario de Salud Digital",
  note:
    "Nota: Los datos del Monitor de salud digital mundial se mostrarán públicamente. Por tal razón, por favor obtenga la aprobación de la " +
    "agencia gubernamental pertinente (Ministerio de Salud, Agencia de Salud Digital, etc.) y proporcione la información de contacto de la " +
    "persona encargada de la aprobación. Al salir de esta página se descartarán los cambios no guardados.",
  contactForm: {
    contactInformation: "Información de contacto",
    nameOfPersonEnteringData: "Nombre de la persona que introduce los datos",
    roleOfThePersonEnteringData: "Cargo de la persona que introduce los datos",
    emailOfThePersonEnteringData:
      "Correo electrónico de la persona que introduce los datos",
    nameOfTheApprover:
      "Nombre de la persona que aprobó la introducción de los datos",
    roleOfTheApprover:
      "Cargo de la persona que aprobó la introducción de los datos ",
    emailOfTheApprover:
      "Correo electrónico de la persona que aprobó la introducción de los datos",
    nameOfTheCountryContact: "Nombre de la persona de contacto en el país ",
    roleOfTheCountryContact: "Cargo de la persona de contacto en el país",
    emailOfTheCountryContact:
      "Correo electrónico de la persona de contacto en el país",
    countrySummary: "Resumen del país ",
    organisationOfTheCountryContact: "Organización de contacto en el país",
    govtApprovedMessage: "¿Los datos están aprobados por el gobierno?",
    error: {
      nameOfPersonEnteringData:
        "Nombre de la persona que introduce los datos es obligatorio",
      roleOfThePersonEnteringData:
        "El papel de la persona que introduce los datos es obligatorio",
      email: "Por favor, introduzca un correo electrónico válido",
      nameOfTheApprover:
        "Nombre de la persona que autoriza los datos es obligatorio",
      roleOfTheApprover:
        "Se requiere la función de la persona que autoriza los datos",
      nameOfTheCountryContact: "El contacto del país es obligatorio",
      roleOfTheCountryContact:
        "El papel del contacto en el país es obligatorio",
      countrySummary: "Resumen del país es obligatorio",
      organisationOfTheCountryContact: "Por favor, introduzca la organización",
    },
    hoverText: {
      nameOfPersonEnteringData:
        "Por favor, introduzca el nombre de la persona que introduce los datos",
      roleOfThePersonEnteringData:
        "Introduzca el rol de la persona que introduce los datos",
      email: "Ingresar correo electrónico",
      nameOfTheApprover:
        "Por favor, introduzca el nombre de la persona que aprueba los datos",
      roleOfTheApprover:
        "Introduzca el rol de la persona que autoriza los datos",
      nameOfTheCountryContact: "Contacto en el país",
      roleOfTheCountryContact: "Papel del contacto en el país",
      organisationOfTheCountryContact: "Entrar organización del país contacto",
    },
  },
  resourceForm: {
    resourceInformation: "Información sobre recursos",
    note: "Por favor, proporcione enlaces a recursos relacionados con la salud digital para su país.",
    exampleFormat: "Ejemplo de formato : www.example.com",
    resource: "Recurso {number}",
    errorMessage: "Por favor, introduzca un enlace de recursos válido",
  },
  notifications: {
    submit: "Formulario enviado para su revisión",
    saveCorrection: "Formulario guardado con éxito!",
    save: "Formulario guardado con éxito!",
    publish: "Los datos ya están en vivo",
    download: "Descarga iniciada con éxito",
    correctTheHighlightedFields: "Por favor, corrija los campos resaltados.",
    somethingWentWrong: "Algo ha salido mal. Por favor, actualice la página!",
  },
  indicatorDetails: "Detalles del indicador",
  indicatorScoreError:
    "La puntuación del indicador y el campo de justificación son obligatorios.",
  rationaleOrSupportingText: "Justificación o texto de apoyo",
  downloadPDF: "DESCARGAR PDF",
  saveAsDraft: "GUARDAR COMO BORRADOR",
  submit: "ENVIAR",
  save: "Guardar",
  reject: "Rechazar",
  publish: "Publicar",
  republish: "Republicar",
  confirm: "Confirmar",
  cancel: "Cancelar",
  note1: "Estos detalles se mostrarán públicamente en la plataforma GDHM.",
  note2:
    "Estos detalles no aparecerán en la plataforma de GDHM y son para nuestro propósito informativo.",
  note3:
    "Seul le score de chaque indicateur sera affiché publiquement sur la plateforme GDHM.",
  publishConfirmation:
    "Está a punto de publicar un formulario de índice de salud digital para {country}. Que no se puede revertir. ¿Quieres continuar?",
  republishConfirmation:
    "Está a punto de volver a publicar el formulario de índice de salud digital para {país}. Esto no se puede revertir. ¿Quieres continuar?",
  saveConfirmation:
    "¿Está seguro de que desea enviar los datos de {country}? Verifique que las opciones seleccionadas por usted reflejen la madurez de salud digital del año actual del país",
  rejectConfirmation:
    "Está a punto de rechazar un formulario de índice de salud digital para {country. Que no se puede revertir. ¿Quieres continuar?",
  govtApprovedMessage: "¿Los datos están aprobados por el gobierno?",
  QuestionnaireStateMessage: {
    hasPrefillData:
      "Los datos se han rellenado previamente en el cuestionario desde el año {updatedDate}. Actualice los datos del año actual y proporcione la justificación pertinente.",
    dataSubmittedAlready:
      "Los datos ya se enviaron para el año actual el {updatedDate}",
    dataPublishedAlready:
      "Los datos del año en curso ya están publicados el {updatedDate}",
  },
};
